/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelDataSharingRequestsDto
 */
export interface CancelDataSharingRequestsDto {
    /**
     * Array of patient IDs to cancel
     * @type {Array<string>}
     * @memberof CancelDataSharingRequestsDto
     */
    patientIds: Array<string>;
}

/**
 * Check if a given object implements the CancelDataSharingRequestsDto interface.
 */
export function instanceOfCancelDataSharingRequestsDto(value: object): value is CancelDataSharingRequestsDto {
    if (!('patientIds' in value) || value['patientIds'] === undefined) return false;
    return true;
}

export function CancelDataSharingRequestsDtoFromJSON(json: any): CancelDataSharingRequestsDto {
    return CancelDataSharingRequestsDtoFromJSONTyped(json, false);
}

export function CancelDataSharingRequestsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelDataSharingRequestsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientIds': json['patientIds'],
    };
}

export function CancelDataSharingRequestsDtoToJSON(json: any): CancelDataSharingRequestsDto {
    return CancelDataSharingRequestsDtoToJSONTyped(json, false);
}

export function CancelDataSharingRequestsDtoToJSONTyped(value?: CancelDataSharingRequestsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientIds': value['patientIds'],
    };
}

